import { DropdownButton, FormControl, MenuItem } from 'react-bootstrap';

import utils from '../../../utils';
import type { UpdateHookScheduledInterval } from '../../../../shared/model-typings';

export type ScheduledUpdateHookConfigSettingsUpdateHook = {
  scheduledInterval?: UpdateHookScheduledInterval;
  scheduledIntervalLength?: number;
  scheduledIntervalTime?: string;
};

type ScheduledUpdateHookConfigSettingsProps = {
  updateHook: ScheduledUpdateHookConfigSettingsUpdateHook;
  onUpdateHookChange: Function;
}

const ScheduledUpdateHookConfigSettings = ({
  updateHook,
  onUpdateHookChange,
}: ScheduledUpdateHookConfigSettingsProps) => {
  const scheduledIntervalLength = updateHook.scheduledIntervalLength || 2;
  const scheduledInterval = updateHook.scheduledInterval || 'day';
  const scheduledIntervalTime = updateHook.scheduledIntervalTime || '24:00:00';

  return (
    <div className="scheduled-update-hook-container">
      <div className="row">
        <div className="col-md-3">Update every:</div>
        <div className="col-md-9">
          <FormControl
            bsSize="sm"
            style={{
              width: '70px',
              borderRadius: '0',
              border: '1px solid rgba(85, 104, 130, 0.4)',
              display: 'inline',
              marginRight: '10px',
            }}
            type="number"
            value={scheduledIntervalLength}
            onChange={(e: any) => {
              onUpdateHookChange(Object.assign(
                updateHook,
                {
                  scheduledIntervalLength: e.target.value,
                },
              ));
            }}
          />

          <DropdownButton
            id="updateHooksIntervalButton"
            style={{
              borderRadius: 0,
              color: '#555',
            }}
            title={`${utils.capitalizeWord(scheduledInterval)}(s)`}
            onSelect={interval => {
              onUpdateHookChange(Object.assign(
                updateHook,
                {
                  scheduledInterval: interval,
                  scheduledIntervalLength: 1,
                  scheduledIntervalTime:
                    interval !== 'day' ? null : scheduledIntervalTime,
                },
              ));
            }}>
            <MenuItem eventKey="hour">Hour(s)</MenuItem>
            <MenuItem eventKey="day">Day(s)</MenuItem>
            <MenuItem eventKey="week">Week(s)</MenuItem>
          </DropdownButton>
        </div>
      </div>
      {scheduledInterval === 'day' ? (
        <div className="row">
          <div className="col-md-3">Update time:</div>
          <div className="col-md-9">
            <TimePicker updateHook={updateHook} onUpdateHookChange={onUpdateHookChange} />
          </div>
        </div>
      ) : null}
      <p>
        <b>NOTE:</b> Time zone is Pacific Time (PT)
      </p>
    </div>
  );
};

export default ScheduledUpdateHookConfigSettings;


const getAMorPM = (hour) =>
  hour < 12 ? 'AM' : 'PM';

const getHourVal = (hour) => {
  if (hour === 0) {
    return 12;
  }

  if (hour > 12) {
    return hour % 12;
  }

  return hour;
};

const getAllTimes = () => {
  const allTimes = [
    <MenuItem key="12am" eventKey="00:00:00">12:00 AM</MenuItem>,
    <MenuItem key="1230am" eventKey="00:30:00">12:30 AM</MenuItem>,
  ];
  for (let i = 1; i < 24; i++) {
    const amOrPm = getAMorPM(i);
    const hour = getHourVal(i);
    allTimes.push(
      <MenuItem eventKey={`${(i < 10 ? '0' : '')}${i}:00:00`}>
        {hour}:00 {amOrPm}
      </MenuItem>,
    );
    allTimes.push(
      <MenuItem eventKey={`${(i < 10 ? '0' : '')}${i}:30:00`}>
        {hour}:30 {amOrPm}
      </MenuItem>,
    );
  }
  return allTimes;
};

export const TimePicker = ({
  updateHook,
  onUpdateHookChange,
}: ScheduledUpdateHookConfigSettingsProps) => {
  let displayTime;
  if (
    !updateHook.scheduledIntervalTime ||
    updateHook.scheduledIntervalTime === '24:00:00'
  ) {
    displayTime = '12:00 AM';
  } else {
    const timeParts = updateHook.scheduledIntervalTime.split(':');
    const numHour = Number(timeParts[0]);
    const amOrPm = getAMorPM(numHour);
    const hour = getHourVal(numHour);
    displayTime = `${hour}:${timeParts[1]} ${amOrPm}`;
  }
  return (
    <DropdownButton
      id="updateHooksTimeIntervalButton"
      style={{
        borderRadius: 0,
        color: '#555',
      }}
      title={displayTime}
      onSelect={time => {
        onUpdateHookChange(Object.assign(
          updateHook,
          {
            scheduledIntervalTime: time,
          },
        ));
      }}>
      {getAllTimes()}
    </DropdownButton>
  );
};
